import { Link } from "react-router-dom";
import { ArrowUp } from "lucide-react";
import { Magnetic } from "./Shared";

const cols = [
  {
    title: "Advisory",
    links: [
      { label: "About", href: "#about" },
      { label: "Services", href: "#practice" },
      { label: "Mandates", href: "#mandates" },
    ],
  },
  {
    title: "Connect",
    links: [
      { label: "Voices", href: "#voices" },
      { label: "Contact", href: "#contact" },
      { label: "info@adi-semaradana.com", href: "mailto:info@adi-semaradana.com" },
      { label: "+1 888 557 6994", href: "tel:+18885576994" },
    ],
  },
  {
    title: "Registered",
    links: [
      { label: "30 N Gould St Ste R", href: "#contact" },
      { label: "Sheridan, WY 82801", href: "#contact" },
      { label: "United States", href: "#contact" },
    ],
  },
];

export default function Footer() {
  return (
    <footer data-testid="footer" className="relative overflow-hidden">
      <div className="max-w-[1800px] mx-auto px-6 md:px-12 pt-24 md:pt-32">
        <div className="grid md:grid-cols-12 gap-12 pb-20">
          <div className="md:col-span-5">
            <p className="font-serif text-2xl tracking-tight">I Putu Adi Semarada LLC</p>
            <p className="mt-4 max-w-xs text-sm leading-relaxed text-black/55 font-light">
              Independent, owner-side property consulting for global owners of prime UK real estate — advisory,
              refurbishment oversight, and operator stewardship. We never sell, let, or manage the assets we advise on.
            </p>
          </div>
          {cols.map((c) => (
            <nav key={c.title} className="md:col-span-2" aria-label={c.title}>
              <p className="font-mono text-[10px] uppercase tracking-[0.3em] text-[#D4512D] mb-6">{c.title}</p>
              <ul className="space-y-3">
                {c.links.map((l) => (
                  <li key={l.label}>
                    <a
                      href={l.href}
                      data-testid={`footer-link-${l.label.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
                      className="link-sweep text-sm text-black/60 hover:text-black font-light transition-colors duration-300"
                    >
                      {l.label}
                    </a>
                  </li>
                ))}
              </ul>
            </nav>
          ))}
          <div className="md:col-span-1 flex md:justify-end items-start">
            <Magnetic>
              <a
                href="#top"
                data-testid="back-to-top-button"
                aria-label="Back to top"
                className="inline-flex items-center justify-center w-14 h-14 rounded-full border border-black/25 hover:bg-[#0A0A0A] hover:text-[#F4F3EF] hover:border-[#0A0A0A] transition-colors duration-300"
              >
                <ArrowUp size={18} strokeWidth={1.5} />
              </a>
            </Magnetic>
          </div>
        </div>
      </div>

      <div className="border-t border-black/15">
        <div className="max-w-[1800px] mx-auto px-6 md:px-12 py-6 flex flex-col md:flex-row items-center justify-between gap-3 font-mono text-[10px] uppercase tracking-[0.25em] text-black/45">
          <span data-testid="footer-copyright">© 2026 I Putu Adi Semarada LLC</span>
          <span className="flex items-center gap-6">
            <Link to="/privacy" data-testid="footer-link-privacy-policy" className="hover:text-black transition-colors duration-300">
              Privacy Policy
            </Link>
            <Link to="/terms" data-testid="footer-link-terms-conditions" className="hover:text-black transition-colors duration-300">
              Terms &amp; Conditions
            </Link>
          </span>
          <span>Registered in Wyoming, USA</span>
          <span>Independent · Fee-for-service · Confidential</span>
        </div>
      </div>
    </footer>
  );
}
